var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickDataBluish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16.3704V2.51852H0V0ZM0 5.03704H16.3704V7.55556H0V5.03704ZM6.92578 10.0741H0V12.5926H6.92578V10.0741Z",
    fill: "#8DABC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2905 14.4651L11.0828 12.2575C10.9639 12.1386 10.8025 12.0717 10.6343 12.0717C10.4661 12.0717 10.3047 12.1386 10.1858 12.2575C10.0668 12.3765 10 12.5378 10 12.706C10 12.7893 10.0164 12.8718 10.0483 12.9488C10.0802 13.0257 10.1269 13.0957 10.1858 13.1546L12.8451 15.8139C13.0933 16.062 13.4941 16.062 13.7422 15.8139L20.4733 9.08284C20.5922 8.96388 20.659 8.80254 20.659 8.63431C20.659 8.46608 20.5922 8.30474 20.4733 8.18579C20.3543 8.06683 20.193 8 20.0247 8C19.8565 8 19.6952 8.06683 19.5762 8.18579L13.2905 14.4651Z",
    fill: "#8DABC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDataBluish);
export default __webpack_public_path__ + "static/media/tickData_bluish.71e0e6a99a85f775649543bcacb9967c.svg";
export { ForwardRef as ReactComponent };